export function getContactFormHandlerUrl() {
  const baseUrl = process.env.REACT_APP_API_URL?.trim();
  const normalizedBaseUrl = baseUrl ? baseUrl.replace(/\/+$/, "") : "";

  return normalizedBaseUrl
    ? `${normalizedBaseUrl}/contact-form-handler.php`
    : "/contact-form-handler.php";
}
